const plusZoomButton = $('.zoom-plus');
const minusZoomButton = $('.zoom-minus');
const percentageLabel = $('#percentage');
const container = $('#blueimp-gallery');
const containerSlide = $('#blueimp-gallery .slides');
const grabAndScrollHandler = require('../grabAndScroll/grabAndSroll');

/**
 * Adiciona os listeners dos zooms
 */
function applyListenerImageViewer() {
  plusZoomButton.on('click', plusZoom);
  minusZoomButton.on('click', minusZoom);
  container.on('wheel', handleWheelZoom);

  // Precisa utilizar essa sintaxe pra que aplique os listeners nos modais dinamicos de despesa
  $(document).on('click','[data-custom-gallery]',function (e) {
    e.preventDefault();

    const href = $(this).attr('href') || $(this).data('href');
    // Inicia a nova galeria com as configurações corretas
    window.blueimp.Gallery([href], {
      closeOnSwipeUpOrDown: false,
      onopened: () => {
        containerSlide.off();
        // Toda vez que abre o modal a api coloca os listeners de gab no slider
        // Aqui removemos e adicionamos o nosso
        grabAndScrollHandler.handler(containerSlide[0]);

        const container = $('#blueimp-gallery');
        const image = container.find('img');

        // Caso a imagem tenha mais height do que deveria descentraliza ela e permite scroll
        const isOverflowing = image[0].clientWidth > containerSlide[0].scrollWidth
        || image[0].clientHeight > containerSlide[0].scrollHeight;

        if (!containerSlide.hasClass('no-display-center') && isOverflowing) {
          containerSlide.addClass('no-display-center');
        }
      }
    });

    return false;
  });
}


/**
 * Controla o zoom da imagem do blue-imp pelo wheel do mouse
 */
function handleWheelZoom(event) {
  const delta = event.originalEvent.wheelDelta;
  const container = $('#blueimp-gallery');
  const image = container.find('img');

  if (delta > 0) {
    plusZoom();
    return;
  }

  minusZoom();

  // Caso a imagem tenha mais height do que deveria descentraliza ela e permite scroll
  const isOverflowing = image[0].clientWidth > containerSlide[0].scrollWidth
  || image[0].clientHeight > containerSlide[0].scrollHeight;

  if (!containerSlide.hasClass('no-display-center') && isOverflowing) {
    containerSlide.addClass('no-display-center');
  }
}

/**
 * Controla o zoom da imagem do blue-imp (menos)
 */
function minusZoom() {
  const container = $('#blueimp-gallery');
  const image = container.find('img');
  const currentZoom = parseFloat(image.css('transform').split(',')[3]);

  if ((currentZoom - 0.25) < 1) {
    return;
  }

  image.css('transform', `scale(${currentZoom - 0.25})`);
  percentageLabel.html(`${(currentZoom - 0.25) * 100}%`)

  // Caso a imagem tenha mais height do que deveria descentraliza ela e permite scroll
  const isOverflowing = image[0].getBoundingClientRect().width > containerSlide[0].scrollWidth
  || image[0].getBoundingClientRect().height > containerSlide[0].scrollHeight;

  if (!containerSlide.hasClass('no-display-center') && isOverflowing) {
    containerSlide.addClass('no-display-center');
  } else if (containerSlide.hasClass('no-display-center')  && !isOverflowing) {
    containerSlide.removeClass('no-display-center');
  }
}

/**
 * Controla o zoom da imagem do blue-imp (mais)
 */
function plusZoom() {
  const container = $('#blueimp-gallery');
  const image = container.find('img');
  const currentZoom = parseFloat(image.css('transform').split(',')[3]);

  if ((currentZoom + 0.25) > 3) {
    return;
  }

  image.css('transform', `scale(${currentZoom + 0.25})`);
  percentageLabel.html(`${(currentZoom + 0.25) * 100}%`)

  // Caso a imagem tenha mais height do que deveria descentraliza ela e permite scroll
  const isOverflowing = image[0].getBoundingClientRect().width > containerSlide[0].scrollWidth
  || image[0].getBoundingClientRect().height > containerSlide[0].scrollHeight;

  if (!containerSlide.hasClass('no-display-center') && isOverflowing) {
    containerSlide.addClass('no-display-center');
  } else if (containerSlide.hasClass('no-display-center')  && !isOverflowing) {
    containerSlide.removeClass('no-display-center');
  }
}


module.exports = {
  init: applyListenerImageViewer,
  // Aplicavel somente nas paginas de despesa, relatório e aprovação ( modais e show )
  url: /^\/despesas|^\/relatorios|^\/despesas\/\d+|^\/relatorios\/\d+|^\/aprovacoes\/\d+|^\/aprovacoes\/despesas\/\d+/,
};

